module.exports = __webpack_public_path__ + "img/10.85494aa4.jpg";